const DATE_OPTS = { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "UTC" };

export const fmtDate = (d) =>
  d ? new Date(d).toLocaleDateString("es-PE", DATE_OPTS) : "-";
